<!--
 * @Description:
 * @version:
 * @Author: 李云飞
 * @Date: 2020-10-22 11:00:31
 * @LastEditors: 李云飞
 * @LastEditTime: 2020-10-22 11:10:44
-->
<template>
  <div class="agreement">
    <div class="header">
        <div class="company-name">
          <nuxt-link class="logo" :style="`background-image: url('${getLogoUrl}')`"
                     to="/">
          </nuxt-link>
          {{getSiteName}}
        </div>
      <div class="fr">
        <span>让教育更公平</span>让学习更简单
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AgreementHeader',
  components: {},
  filters: {},
  props: {},
  data () {
    return {

    };
  },
  computed: {
    getLogoUrl () {
      const companyInfo = this.$store.state.companyInfo || {};
      return companyInfo.companyLogo;
    },
    getSiteName () {
      const companyInfo = this.$store.state.companyInfo || {};
      return companyInfo.siteName;
    }
  },
  watch: {},
  created () {
  },
  mounted () {
  },
  methods: {
  }
};
</script>
<style lang='less' scoped>
.agreement {
  background-color: #fff;
  .header {
    width: 1200px;
    height: 124px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .company-name {
      display: flex;
      height: 34px;
      line-height: 34px;
      font-size: 26px;
      font-weight: 800;
      letter-spacing: 2px;
      margin-bottom: 4px;
      align-items:center;
    }

      .logo {
        display: block;
        width: 42px;
        height: 42px;
        margin-right: 24px;
        background-size: cover;
      }

    .fr {
      height: 34px;
      line-height: 34px;
      color: #414141;
      font-size: 26px;
      font-weight: 700;
      position: relative;
      padding-left: 20px;
      &::before {
        content: "";
        width: 1px;
        height: 100%;
        background: #eee;
        position: absolute;
        left: 0;
        top: 0;
      }
      span {
        padding-right: 20px;
      }
    }
  }
}
</style>
